import { State } from "../../../state";
import { ApplyActionVisibility } from "../_CostsAndOutcomes/ApplyActionVisibility";
import { ApplyCosts } from "../_CostsAndOutcomes/ApplyCosts";
import { ApplyOutcomes } from "../_CostsAndOutcomes/ApplyOutcomes";
import { meetsCostRequirements } from "../_CostsAndOutcomes/meetsCostRequirements";
import { applyAchievementChecks } from "../../../Achievements/checkAchievements";

export const Split3004into3023 = (actionId: string, state: State) => {
  const newBricks = new Map(state.bricks);
  const newActions = new Map(state.actions);
  const newActionTimestamps = state.actionTimestamps;
  const newBricksCollectedByType = state.bricksCollectedByType;
  const newActionsTriggeredByType = state.actionsTriggeredByType;

  const action = new Map(state.actions).get(actionId)!;
  const brick_3023 = newBricks.get("3023")!;

  if (!meetsCostRequirements(action, newBricks)) {
    return state;
  } else {
    // Update amount if set to default NaN
    if (Number.isNaN(brick_3023.amount)) brick_3023.amount = 0;
  }

  // Max Capacity reached
  if (brick_3023.amount === brick_3023.capacity) return state;

  // Apply Action Visibility
  const { newActions: updatedActions, newActionOrder } = ApplyActionVisibility(
    action,
    newActions,
    state.actionOrder,
  );

  // Apply Costs
  // null = result of applied costs are negative.  Should be caught during meetCostRequirements
  if (ApplyCosts(action, newBricks, newActionTimestamps) === null) return state;

  // Apply Outcomes
  // null = default case was triggered
  if (ApplyOutcomes(action, newBricks, newActionTimestamps) === null)
    return state;

  // Apply Increase in costScale
  // N/A

  // Apply Achievement Data
  const newBricksAmt = newBricksCollectedByType.get("3023") ?? 0;
  newBricksCollectedByType.set("3023", newBricksAmt + 3);

  const newActionsAmt = newActionsTriggeredByType.get(actionId) ?? 0;
  newActionsTriggeredByType.set(actionId, newActionsAmt + 1);

  const newState = {
    ...state,
    actionTimestamps: newActionTimestamps,
    bricks: newBricks,
    actions: updatedActions,
    actionOrder: newActionOrder,
    totalBricksCollected: state.totalBricksCollected + 3,
    totalActionsTriggered: state.totalActionsTriggered + 1,
    bricksCollectedByType: newBricksCollectedByType,
    actionsTriggeredByType: newActionsTriggeredByType,
  };

  return applyAchievementChecks(newState);
};
